/*
 * Testimonials scroll controls. Spec: docs/social-proof-spec.md.
 *
 * Progressive enhancement: the row is a plain overflow-x scroller and works with touch, a
 * trackpad and keyboard without any of this. The arrows are revealed only once JS confirms the
 * row actually overflows — showing a disabled arrow pair on a row that fits looks broken.
 */
(function () {
  'use strict';

  function initSection(section) {
    var track = section.querySelector('[data-testimonials-track]');
    var nav = section.querySelector('[data-testimonials-nav]');
    if (!track || !nav) return;

    var prev = nav.querySelector('[data-testimonials-prev]');
    var next = nav.querySelector('[data-testimonials-next]');

    function overflows() {
      return track.scrollWidth - track.clientWidth > 4;
    }

    function syncArrows() {
      if (!overflows()) {
        nav.hidden = true;
        return;
      }
      nav.hidden = false;
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    /* Scroll by one card plus its gap, read from the DOM rather than hardcoded. */
    function step() {
      var card = track.querySelector('.kardima-testimonial');
      if (!card) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    /*
     * Assigns scrollLeft directly and lets CSS `scroll-behavior: smooth` do the animating,
     * rather than passing behavior through scrollBy(). Equivalent in a real browser; this
     * form is just less indirection.
     *
     * TESTING NOTE: in a hidden/paused document ANY programmatic scroll silently no-ops while
     * `scroll-behavior: smooth` is in effect — scrollBy and a plain scrollLeft assignment
     * alike. It looks exactly like a broken handler. To verify, force
     * `scroll-behavior: auto !important` first; the arrows then step 360 -> 720 -> 360 and
     * disable correctly at each end (measured).
     */
    function scrollByCards(direction) {
      var max = track.scrollWidth - track.clientWidth;
      var target = track.scrollLeft + direction * step();
      track.scrollLeft = Math.max(0, Math.min(target, max));
      syncArrows();
    }

    prev.addEventListener('click', function () {
      scrollByCards(-1);
    });
    next.addEventListener('click', function () {
      scrollByCards(1);
    });

    track.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);

    // Card widths depend on fonts having loaded, so re-measure once they have.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncArrows);
    syncArrows();
  }

  function init() {
    document.querySelectorAll('.kardima-testimonials').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var s = event.target.querySelector('.kardima-testimonials');
    if (s) initSection(s);
  });
})();
